<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 aria-label="Finish"
                 role="dialog"
                 size="lg"
    >
        <div slot="header">
            <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
            <h3 class="modal-title">Finish {{ 'Goal'|customTerm }}</h3>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group form-labels">
                    <label for="impact-textarea">Before you finish...</label>
                    <p class="textarea-description">Say something about how this Goal has helped you, or the person you
                        are supporting.
                        What's different or better now?</p>
                    <textarea
                            id="impact-textarea"
                            class="form-control"
                            v-model="impactText"
                            rows="4"
                    ></textarea>
                </div>
            </div>
        </div>
        <div slot="footer">
            <div class="row">
                <div class="col-xs-12 ">
                    <button class="btn btn-mm btn-green save-button" @click="ok">
                        Next
                    </button>
                </div>
            </div>
        </div>
    </basic-modal>
</template>

<script>
    import PopupPromiseMixin from '~/vue/mixins/PopupPromiseMixin';

    export default {
        mixins: [PopupPromiseMixin],
        props: {
            initialText: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                impactText: '',
            };
        },
        created() {
            this.impactText = this.initialText;
        },
        methods: {
            ok() {
                this.save(this.impactText);
            },
            setInitial(initialText = '') {
                if (initialText) {
                    this.impactText = initialText;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
  @import "../../styles/const";

  .textarea-description {
    margin-bottom: 10px;
    font-size: 14px;
  }

  textarea {
    resize: vertical;
  }

  .form-labels, .textarea-description {
    font-size: $slight-bigger-font-size;
  }
</style>
